/**
 * @param {import("./typedefs").RawBankAccountChangeRequest} resp
 * @returns {import("./typedefs").BankAccountChangeRequest}
 * */
export function transformResponseData(resp) {
  return {
    is_processing: resp?.is_processing,
    num_attempt: resp?.num_attemp,
    max_attempt: resp?.max_attemp,
    ...resp,
  };
}
